@if (tippy.data; as serviceItem) {
  <div class="weapon-tooltip">
    <div class="weapon-tooltip__name">
      {{ ITEM_TYPE_NAME[serviceItem.type] }}
    </div>
    <div class="weapon-tooltip__header">
      <div class="weapon-tooltip__type">
        {{ serviceItem.name }}
      </div>
    </div>

    @if (serviceItem.maxValueUsd > 0) {
      <div class="weapon-tooltip__footer">
        <div class="weapon-tooltip__price">
          @if (serviceItem.minValueUsd !== serviceItem.maxValueUsd) {
            <ng-container i18n="@@service_items.tooltip_avg_value">Ценность до</ng-container>
          } @else {
            <ng-container i18n="@@service_items.tooltip_value">Ценность</ng-container>
          }

          <span class="weapon-tooltip__maxValue"
            [convert]="serviceItem.maxValueUsd"
          ></span>
        </div>
      </div>
    }
  </div>
}